import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Typography from '@src/new-components/Typography';
import NewActionsHeader from '@src/containers/Layout/NewActionsHeader';
import NewPackageInfoV3 from '@src/containers/Layout/SidebarNew/NewPackageInfoV3';
import { NEW_ACTIONS_HEADER_MENU } from '@src/constants';
import ROUTES from '@src/constants/route';
import actions from '@src/redux/actions';
import { COLOR } from '@src/styles/color';
import { StyledEducatorsHomeHeader } from './index.style';

const Header = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <StyledEducatorsHomeHeader>
      <div className="header-title">
        <Typography variant="body-20-bold" color={COLOR.label2[100]}>
          {t('home')}
        </Typography>
      </div>
      <div className="header-actions">
        <NewActionsHeader
          menuShow={[
            NEW_ACTIONS_HEADER_MENU.LEADERBOARD_VOICE,
            NEW_ACTIONS_HEADER_MENU.TASK_CREDIT,
            NEW_ACTIONS_HEADER_MENU.NOTIFICATION,
            NEW_ACTIONS_HEADER_MENU.GUIDE_CREDIT,
          ]}
          onTaskCredits={() =>
            dispatch(actions.layout.setShowOnboardingPopup(true))
          }
          onLeaderboardVoice={() => history.push(ROUTES.VOICE_LEADERBOARD)}
          margin="0px"
        />
        <NewPackageInfoV3 />
      </div>
    </StyledEducatorsHomeHeader>
  );
};

export default Header;
